<template>
    <div class="menu-btn" :class="{open: isOpen}" @click="openOrClose()">
        <div class="menu-to-close-btn"  >
        
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
        }
    },
    computed: {
        isOpen: {
            get() {
                return this.status
            },
            set(val) {
                this.$emit('update:status', val)
            }
        }
    },
    props: {
        disable: {
            type: Boolean,
            default:() => {
                return false
            }
        },
        status: {
            type: Boolean,
            default: () => {
                return false
            }
        }
    },
    methods: {
        openOrClose () {
            if (this.disable) {
                console.log('menu disable activate')
                return false
            }
            this.isOpen = this.isOpen ? false : true
            console.log(this.isOpen, this.isOpen = this.isOpen ? false : true)
        }
    }
}
</script>
<style scoped>
.menu-to-close-btn::before{
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    -webkit-transition-duration: .2s;
    transition-duration: .2s;
    bottom: 100%;
    margin-bottom: 5px;
}
.menu-to-close-btn {
    display: block;
    background-color: #000;
    -webkit-transition: background-color .2s;
    transition: background-color .2s;
    position: relative;
    height: 3px;
    
}
.menu-to-close-btn::after{
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    -webkit-transition-duration: .2s;
    transition-duration: .2s;
    top: 100%;
    margin-top: 5px;
}
.open .menu-to-close-btn {
    transform: rotate(180deg);
    background: transparent;
}
.open .menu-to-close-btn::before {
    transform: rotate(45deg);
    margin-bottom: -3px;
}
.open .menu-to-close-btn::after {
    transform: rotate(-45deg);
    margin-top: -3px;
}
.menu-btn {
    width: 24px;
    position: relative;
    transition: transform .2s;
    margin: 0 auto 10px;
}
.menu-btn.open {
    transform: rotate(180deg);
}
</style>